(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mj-comparison-v4"] && !Shopify.designMode) return;
  try {
    

// Own only this section's row toggle. Keep the native feature-chart element
// for sticky products and scrolling, but prevent its toggle handler from
// counting product headers as parameter rows.
if (!customElements.get('custom-comparison-row-toggle')) {
  customElements.define('custom-comparison-row-toggle', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const button = event.target.closest('button[data-action="toggle-rows"]');
        if (!button || !this.contains(button)) return;
        const chart = this.closest('feature-chart');
        const table = chart?.querySelector('.feature-chart__table');
        if (!table) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        const maxRows = Math.max(0, Number.parseInt(this.dataset.maxRows, 10) || 0);
        const rows = Array.from(table.children).filter(row =>
          row.classList.contains('feature-chart__table-row') &&
          !row.classList.contains('feature-chart__table-row--product') &&
          !row.classList.contains('feature-chart__table-row--sticky'));

        rows.forEach((row, index) => { row.hidden = !expanded && index >= maxRows; });
        button.setAttribute('aria-expanded', String(expanded));
        const label = button.querySelector('.feature-chart__toggle-text');
        if (label) label.textContent = expanded ? button.dataset.viewLess : button.dataset.viewMore;
        const icon = button.querySelector('.circle-chevron');
        if (icon) icon.style.transform = expanded ? 'rotate(180deg)' : '';
      };
      // Capture before the native button/delegated click listener runs.
      this.addEventListener('click', this.onClick, true);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick, true);
    }
  });
}

if (!customElements.get('custom-comparison-swipe-hint')) {
  customElements.define('custom-comparison-swipe-hint', class extends HTMLElement {
    connectedCallback() {
      // Defer until sibling markup is parsed; each instance owns its observers.
      this.frame = requestAnimationFrame(() => {
        this.table = this.nextElementSibling?.querySelector('.feature-chart__table');
        if (!this.table) return;
        this.update = () => {
          this.toggleAttribute('data-overflow', this.table.clientWidth > 0 &&
            this.table.scrollWidth > this.table.clientWidth + 2);
        };
        this.resizeObserver = new ResizeObserver(this.update);
        this.observeRows = () => {
          this.resizeObserver.disconnect();
          this.resizeObserver.observe(this.table);
          for (const row of this.table.children) this.resizeObserver.observe(row);
          this.update();
        };
        this.mutationObserver = new MutationObserver(this.observeRows);
        this.mutationObserver.observe(this.table, { childList: true, subtree: true });
        this.observeRows();
        this.table.addEventListener('load', this.update, true);
        window.addEventListener('resize', this.update);
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      if (this.update) {
        this.table?.removeEventListener('load', this.update, true);
        window.removeEventListener('resize', this.update);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
